import {
  Stack, SimpleGrid, Skeleton,
} from '@mantine/core';
import { IconReceipt } from '@tabler/icons-react';
import PageHeader from '@/components/PageHeader';
import StatCard from '@/components/StatCard';
import EmptyState from '@/components/EmptyState';
import { useSustainabilityScore } from '@/hooks/usePortalApi';

export default function Sustainability() {
  const { data, isLoading } = useSustainabilityScore();

  return (
    <Stack gap="lg">
      <PageHeader title="Sustainability" description="Your sustainability score and environmental impact" />
      {isLoading ? (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
          {[...Array(3)].map((_, i) => <Skeleton key={i} height={120} radius="md" />)}
        </SimpleGrid>
      ) : !data ? (
        <EmptyState icon={<IconReceipt size={30} />} title="No sustainability data" description="No sustainability score data available" />
      ) : (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
          <StatCard
            title="Overall Score"
            value={data.overall_score != null ? `${data.overall_score}/100` : 'N/A'}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Carbon Footprint"
            value={data.carbon_footprint != null ? `${data.carbon_footprint} kg CO2` : 'N/A'}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Packaging Score"
            value={data.packaging_score != null ? `${data.packaging_score}/100` : 'N/A'}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Local Sourcing"
            value={data.local_sourcing_pct != null ? `${data.local_sourcing_pct}%` : 'N/A'}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Waste Reduction"
            value={data.waste_reduction != null ? `${data.waste_reduction}%` : 'N/A'}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Rank"
            value={data.rank ?? 'N/A'}
            icon={<IconReceipt size={24} />}
          />
        </SimpleGrid>
      )}
    </Stack>
  );
}
